// Uses DecompressionStream API (95% global support)
// Requires: Chrome 80+, Edge 80+, Firefox 113+, Safari 16.4+
// If needed, add pako as polyfill for older browsers

import { describeResource } from '@siteless/resource';
import { doc, getDoc } from 'firebase/firestore';
import avatars from '../config/avatars';
import { database } from '../config/firebase';
import { thisOscarsYear } from '../config/constants';
import { decompressGzipBase64 } from '../util/decompressGzipBase64';
import {
  userProfileSchema,
  allUserProfilesSchema,
  type UserProfileType,
} from './userProfileSchema';

let AllUserProfilesResource = describeResource('AllUserProfiles', {
  get: async () => {
    let cacheDoc = await getDoc(
      doc(database, `all_user_profiles_cache/${thisOscarsYear}`)
    );
    let data = cacheDoc.data();

    if (!data?.usersCompressed) {
      return { users: {} };
    }

    let usersJson = await decompressGzipBase64(data.usersCompressed);
    let usersRaw = JSON.parse(usersJson) as Record<string, Record<string, unknown>>;

    let users: Record<string, UserProfileType> = {};

    for (let [id, userData] of Object.entries(usersRaw)) {
      let {
        avatarBackgroundHex = null,
        avatarId = avatars.AVATAR_4.id,
        handle,
        letterboxdId,
      } = userData;
      try {
        users[id] = userProfileSchema.parse({
          id,
          avatarBackgroundHex,
          avatarId,
          handle,
          letterboxdId,
        });
      } catch (error) {
        console.error('userProfileSchema.parse', id, error);
      }
    }

    return allUserProfilesSchema.parse({ users });
  },
});

export default AllUserProfilesResource;
